module.exports = __webpack_public_path__ + "static/media/fabrika-lukavec-de-bondt-36.b0ef1851.jpg";